import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import splashlogo from '../splash/images/logo.png'
import { Link } from "react-router-dom";
import './login.css'
import * as jose from 'jose';

// After imports, before the base64UrlDecode function

// Add this helper function at the top of the file, after imports
const base64UrlDecode = (str) => {
    // Convert base64Url to base64 by replacing URL-safe chars
    const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
    // Pad with '=' if needed
    const pad = base64.length % 4;
    if (pad) {
        return base64 + '='.repeat(4 - pad);
    }
    return base64;
};

// Define the style with a much higher z-index
const accountLinkStyle = {
    position: 'absolute',
    top: '20px',
    right: '20px',
    color: '#000',
    textDecoration: 'none',
    padding: '10px 20px',
    borderRadius: '5px',
    backgroundColor: '#fff',
    zIndex: 99999  // Increased significantly
};

const Login = () => {
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    // Primary authentication check
    const autoLogin = async () => {
        try {
            console.log("1. Starting autoLogin process");
            setIsLoading(true);
            
            const urlParams = new URLSearchParams(window.location.search);
            const jwt = urlParams.get('token');
            console.log(`2. Checking for JWT token: ${jwt ? "Found" : "Not found"}`);

            if (!jwt) {
                console.log("3a. No JWT - redirecting to Compusult login");
                console.log("LINK TO COMPUSULT:", process.env.REACT_APP_COMPUSULT_LOGIN_URL);
                
                // Ensure the login URL is absolute
                const loginUrl = new URL(
                    process.env.REACT_APP_COMPUSULT_LOGIN_URL || 
                    'https://www.cs4000.me/PlayFi/member/login.asp'
                );
                
                // Determine redirect URL based on environment
                const redirectUrl = window.location.hostname === 'localhost'
                    ? process.env.REACT_APP_REDIRECT_DEV
                    : process.env.REACT_APP_REDIRECT_PROD;
                
                // Add redirect parameter to login URL
                loginUrl.searchParams.append('redirect', redirectUrl);
                
                console.log(`Redirecting to: ${loginUrl.toString()}`);
                window.location.href = loginUrl.toString();
                return false;
            }

            try {
                console.log("3b. JWT found - starting validation");
                
                // Decode the JWT without verification (temporarily)
                const parts = jwt.split('.');
                if (parts.length !== 3) {
                    throw new Error('Invalid JWT format');
                }

                // Decode the payload
                const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
                
                const currentTime = Math.floor(Date.now() / 1000);
                console.log("4. Checking JWT expiration");
                
                if (payload.exp && payload.exp <= currentTime) {
                    console.log("5a. JWT has expired");
                    window.location.href = process.env.REACT_APP_COMPUSULT_LOGIN_URL;
                    return false;
                }

                const remainingTime = payload.exp ? payload.exp - currentTime : 0;
                const remainingMinutes = Math.floor(remainingTime / 60);
                console.log(`5b. JWT valid - expires in ${remainingMinutes} minutes`);

                console.log("6. Storing JWT values in localStorage");
                localStorage.setItem('Compusult-userId', payload.sub);
                localStorage.setItem('Compusult-username', payload.username);
                localStorage.setItem('Compusult-credits', payload.credits);
                localStorage.setItem('Compusult-freePlayPoints', payload['free-play-points']);
                localStorage.setItem('Compusult-jwt', jwt);

                console.log("7. autoLogin completed successfully");
                return true;

            } catch (error) {
                console.log(`ERROR in JWT processing: ${error}`);
                window.location.href = process.env.REACT_APP_COMPUSULT_LOGIN_URL;
                return false;
            }
        } catch (error) {
            console.log(`ERROR in autoLogin: ${error}`);
            alert("Login failed. Please try again.");
            return false;
        }
    };

    // Secondary login to your API
    const chetuLogin = async () => {
        console.log(`X. chetuLogin"}`);
        try {
            console.log("8. Starting chetuLogin");
            const chetuUsername = "Max";
            const chetuPassword = "Max";

            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/Account/Login`, {
                "username": chetuUsername,
                "password": chetuPassword,
            });

            if (response.data.status === true) {
                console.log("10. Chetu login successful");
                const token = response.data.data.token;
                const userId = response.data.data.userId;
                
                localStorage.setItem("token", token);
                localStorage.setItem("UserId", userId);
                
                setIsLoading(false);
                navigate('/splash', { replace: true });
            } else {
                console.log("ERROR: Chetu login failed - invalid credentials");
                alert("please check your login details");
            }
        } catch (error) {
            console.log(`ERROR in chetuLogin: ${error}`);
            throw error;
        }
    };

    // Orchestrates the login flow
    const initializeAuth = async () => {
        console.log("0. Starting initializeAuth");
        const primaryAuthSuccess = await autoLogin();
        console.log(`7a. autoLogin result: ${primaryAuthSuccess}`);
        
        if (primaryAuthSuccess) {
            console.log("7b. Primary auth successful, proceeding to secondary login");
            await chetuLogin();
        }
    };

    useEffect(() => {
        initializeAuth();
    }, []);

    if (isLoading) {
        return (
            <>
                <a 
                    href={process.env.REACT_APP_COMPUSULT_OFFICE_URL}
                    style={accountLinkStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Account
                </a>
                <div>Loading...</div>
            </>
        );
    }

    return (
        <>
            <a 
                href={process.env.REACT_APP_COMPUSULT_OFFICE_URL}
                style={accountLinkStyle}
                target="_blank"
                rel="noopener noreferrer"
            >
                Account
            </a>

            <div className='splash-bg'>
                {/* Your existing content */}
            </div>
        </>
    );
};

export default Login